export default "__VITE_ASSET__BREm9oQe__"